import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Container, Form, Image, Row} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import LocalDataService from "../../api/LocalDataService";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChartPie, faLink, faMobileScreen, faUser} from "@fortawesome/free-solid-svg-icons";
import ApiService from "../../api/ApiService";
import CardInfoModal from "./CardInfoModal";
import WithdrawModal from "./WithdrawModal";
import {copyToClipboard} from "../../utils/clipboardUtils";

const PromotionPage = () => {

    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const api = new ApiService();
    const [inviteInfo, setInviteInfo] = useState(null);
    const [cardInfoVisible, setCardInfoVisible] = useState(false);
    const [withdrawVisible, setWithdrawVisible] = useState(false);

    useEffect(() => {
        const userData = LocalDataService.load_user_data();
        if (!userData) {
            toast.error('请先登录');
            return navigate("/home");
        }
        setUser(userData);
        //用户的分销信息获取
        getInviteInfo();
        // 添加事件监听器
        const handleUserLoginStatusChange = () => {
            const userData = LocalDataService.load_user_data();
            setUser(userData);
        };

        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, []);
    function getInviteInfo(){
        api.getUserInviteInfo().then(res => {
            setInviteInfo(res.data)
        })
    }
    function cashWithdrawal() {
        if (inviteInfo?.amount<=0){
            return toast.error('没有可提现金额');
        }
        if (inviteInfo?.amount<30){
            return toast.error('最低提现金额为30元');
        }
        if (!inviteInfo?.sign){
            setCardInfoVisible( true);
            return toast.error('请先实名认证');
        }
        setWithdrawVisible(true);

    }

    return (
        <div className="promotion-page">

            {/* Main Content */}
            <Container className="mt-5">
                <Row style={{position: 'relative'}}>
                    <Col md={6} style={{position: 'relative'}}>
                        <h1 className="text-start mt-5 mx-md-5"
                            style={{color: '#02C8E3', fontSize: '49px'}}>推广赚钱</h1>
                        <p className="text-start mx-md-5"
                           style={{color: '#697880', fontSize: '25px'}}>邀请好友使用推荐产品，好友与你皆有收益</p>
                    </Col>
                    <Col md={6} style={{position: 'relative', alignSelf: 'end'}}>
                        <Image src={'/images/promotion_top_bg.png'} width={'100%'}/>
                    </Col>
                </Row>
                <Row>
                    <Col md={4}>
                        <Card className="bg-dark text-light mb-4">
                            <Card.Body style={{color:'#718088',minHeight:'240px'}}>
                                <div className="d-flex align-items-center mb-3">
                                    <Image
                                        src={user && user.user?.avatar ? user.user.avatar : "/images/default_user.svg"}
                                        roundedCircle={true}
                                        style={{width: '84px', height: '84px',}}/>
                                    <div style={{marginLeft: '10px',color:'white'}}>
                                        <h5>{user?.user?.bindingMobile ? user.user.bindingMobile : '微信用户'}</h5>
                                        <span>ID:{user?.user?.id}</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-1" style={{fontSize:'16px'}}>
                                    <FontAwesomeIcon icon={faMobileScreen} size={'1x'} width={'30px'}/>
                                    <span>
                                        手机号码：{user?.user?.bindingMobile}
                                    </span>
                                </div>
                                <div className="d-flex align-items-center mb-1" style={{fontSize:'16px'}}>
                                    <FontAwesomeIcon icon={faChartPie} size={'1x'}  width={'30px'}/>
                                    <span>
                                        分成比例：{inviteInfo?.ratioG1}%
                                    </span>
                                </div>
                                <div className="d-flex align-items-center mb-1" style={{fontSize:'16px'}}>
                                    <FontAwesomeIcon icon={faUser} size={'1x'} width={'30px'}/>
                                    <span>
                                        实名认证：{inviteInfo?.sign?'已认证':'未认证'}
                                    </span>
                                    <Button variant="primary" size="sm"
                                    onClick={()=>{ setCardInfoVisible( true)}}
                                            style={{
                                        marginLeft: '8px',
                                        background: '#2C2E37',
                                        color: '#02C8E3',
                                        border: 'none',
                                        borderRadius: '50px',
                                    }}>{inviteInfo?.sign?'查看认证':'前去实名'}></Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="bg-dark text-light mb-4">
                            <Card.Body style={{minHeight:'240px'}}>
                                <h5 style={{color:'#718088'}}>可提取金额(元)</h5>
                                <h1 style={{color:'#02C8E3'}}><span style={{fontSize:'20px',}}>¥</span> {(inviteInfo?.amount/100).toFixed(2)}</h1>
                                <Button size="sm" onClick={() => {cashWithdrawal()}} style={{
                                    background: 'linear-gradient(100deg, #02C8E3 0%, #963BC8 130%)',
                                    border: 'none',
                                    borderRadius: '50px',
                                    padding: '5px 30px',
                                    color: '#0A0C0F',
                                    fontWeight: 'bold',
                                    flexShrink: 0,
                                    marginLeft: '10px'
                                }}>申请提现</Button>
                                <small className={'mt-1'} style={{color:'#C8533B',display:'block'}}>*提现金额需满足30元</small>
                                <div className={'mt-1'}>
                                    <small  onClick={() => {navigate('/amountHistoryList')}} style={{color:'#02C8E3',textDecoration:'underline',marginRight:'10px'}}>分成记录></small>
                                    <small  onClick={() => {navigate('/withdrawHistoryList')}} style={{color:'#02C8E3',textDecoration:'underline'}}>提现记录></small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="bg-dark text-light mb-4">
                            <Card.Body  style={{minHeight:'240px'}}>
                                <h5 style={{color:'#718088'}}>累计邀请用户</h5>
                                <h1 style={{color:'#02C8E3'}}>{inviteInfo?.g1Total}</h1>
                                <Button size="sm" onClick={() => {navigate('/inviteTeamList')}} style={{
                                    background: 'linear-gradient(100deg, #02C8E3 0%, #963BC8 130%)',
                                    border: 'none',
                                    borderRadius: '50px',
                                    padding: '5px 30px',
                                    color: '#0A0C0F',
                                    fontWeight: 'bold',
                                    flexShrink: 0,
                                    marginLeft: '10px'
                                }}>查看</Button>
                                <small className={'mt-1'} style={{color:'#718088', display:'block'}}>邀请越多，佣金越高</small>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card className="bg-dark text-light mb-4">
                            <Card.Body>
                                <h6 className={'text-start'}><FontAwesomeIcon icon={faLink} color={'#02C8E3'}
                                                                              size={'1x'}/> 您的专属推广链接</h6>
                                <Form.Group controlId="formReferralLink"
                                            style={{display: 'flex', justifyContent: 'space-between'}}>
                                    <Form.Control type="text" readOnly
                                                  value={'https://feituiai.com/?inviteCode=' + inviteInfo?.inviteCode}
                                                  style={{color: '#697880'}}/>
                                    <Button size="sm"
                                            onClick={() =>
                                                copyToClipboard('https://feituiai.com/?inviteCode=' + inviteInfo?.inviteCode)
                                            }
                                            style={{
                                        background: 'linear-gradient(130deg, #02C8E3 0%, #963BC8 130%)',
                                        border: 'none',
                                        padding: '8px 30px',
                                        color: '#0A0C0F',
                                        fontWeight: 'bold',
                                        flexShrink: 0,
                                        marginLeft: '10px'
                                    }}>复制链接</Button>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row style={{display: 'none'}}>
                    <Col md={12}>
                        <Card className="bg-dark text-light mb-4">
                            <Card.Body>
                                <h5>分成比例升级规则</h5>
                                <Row>
                                    <Col md={4} className="text-center">
                                        <div className="circle-progress blue">
                                            <span>当前邀请人数</span>
                                            <strong>8人</strong>
                                        </div>
                                        <p>成功邀请0-9个付费用户</p>
                                        <p>佣金率：80%</p>
                                    </Col>
                                    <Col md={4} className="text-center">
                                        <div className="circle-progress orange">
                                            <span>当前邀请人数</span>
                                            <strong>28人</strong>
                                        </div>
                                        <p>成功邀请10-30个付费用户</p>
                                        <p>佣金率：80%</p>
                                    </Col>
                                    <Col md={4} className="text-center">
                                        <div className="circle-progress purple">
                                            <span>当前邀请人数</span>
                                            <strong>300人</strong>
                                        </div>
                                        <p>成功邀请30+个付费用户</p>
                                        <p>佣金率：80%</p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Card className="bg-dark text-light mb-4">
                            <Card.Body style={{textAlign: 'left'}}>
                                <h5>说明：</h5>
                                <ol>
                                    <li>佣金比例按照会员等级不同，<span style={{color:'#02C8E3'}}>VIP会员佣金20%</span>，<span style={{color:'#dc3545'}}>SVIP会员升级佣金30%</span>。</li>
                                    <li>被邀请用户开通会员后，邀请人获得佣金，积分充值暂不参与佣金分成</li>
                                    <li>被邀请人开通会员后，佣金根据当前邀请人分佣比例进行计算</li>
                                    <li>邀请人提高分佣比例后，之前的分佣订单不会再次计算</li>
                                    <li>被邀请人退款后，会相应扣除对应佣金</li>
                                </ol>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <CardInfoModal visible={cardInfoVisible} onClose={(isSaveSuccess) =>{
                setCardInfoVisible(false)
                if (isSaveSuccess){
                    getInviteInfo();
                }
            }}/>
            <WithdrawModal visible={withdrawVisible} canWithdrawAmount={(inviteInfo?.amount/100).toFixed(2)} onClose={(isSaveSuccess,openCardInfo) =>{
                setWithdrawVisible(false)
                if (openCardInfo){
                    setCardInfoVisible(true)
                }
                if (isSaveSuccess){
                    getInviteInfo();
                }
            }}/>
        </div>
    );
};

export default PromotionPage;